import { BrowseImageCard } from '@/components/discovery/browse-image-card'
import type { BrowseProject } from '@/api/types'

interface BrowseCardGridProps {
  projects: BrowseProject[]
  isAuthenticated: boolean
  isFavoritedByMe: (projectId: string) => boolean
  expandedIds: Set<string>
  onToggleExpanded: (projectId: string) => void
}

/**
 * Uniform multi-column grid for "Card" mode. Each cell is a fixed-aspect image card; columns
 * scale by viewport. Cards expand independently — any expanded card grows to span 2×2 cells
 * for its info overlay; everything else reflows around expanded tiles via {@code
 * grid-auto-flow: dense}.
 */
export const BrowseCardGrid = ({
  projects,
  isAuthenticated,
  isFavoritedByMe,
  expandedIds,
  onToggleExpanded,
}: BrowseCardGridProps) => (
  <div
    className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6"
    style={{ gridAutoFlow: 'dense' }}
  >
    {projects.map((project) => {
      const isExpanded = expandedIds.has(project.id)
      return (
        <div
          key={project.id}
          className={isExpanded ? 'col-span-2 row-span-2 aspect-square' : 'aspect-square'}
        >
          <BrowseImageCard
            project={project}
            isAuthenticated={isAuthenticated}
            isFavoritedByMe={isFavoritedByMe(project.id)}
            isExpanded={isExpanded}
            onToggleExpanded={onToggleExpanded}
          />
        </div>
      )
    })}
  </div>
)
